import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M23.41 20.59 18.77 16a10.25 10.25 0 1 0-8.52 4.56 10.14 10.14 0 0 0 5.69-1.74l4.65 4.65a2 2 0 0 0 2.82 0 2 2 0 0 0 0-2.88ZM10.25 3A7.25 7.25 0 1 1 3 10.26 7.26 7.26 0 0 1 10.25 3Z"
}), 'Search');